import axios from "@/api/axiosInstance";

export const deleteTeam = async (uuid: string): Promise<void> => {
  await axios.delete(`/api/private/employee-directory/teams/${uuid}`);
};
